import React from 'react';

import ComponentErrorBoundary from 'coreComponents/ComponentErrorBoundary';

import {componentsMap} from './config';
import {IPlaceholderProps} from './IPlaceholder';

const internalPlaceholdersPrefix = '_self_';

const Placeholder = (props: IPlaceholderProps) => {
	const {elementId, data} = props;
	const Component = componentsMap[elementId] as React.FC;
	const componentProps = data || {};
	const isInternalPlaceholder = elementId.startsWith(internalPlaceholdersPrefix);

	if (isInternalPlaceholder) {
		return <></>;
	}

	if (typeof Component === 'undefined') {
		console.error('🔥 <Placeholder /> Missing component for elementId: ', elementId);

		return <></>;
	}

	return (
		<ComponentErrorBoundary>
			<Component {...componentProps} />
		</ComponentErrorBoundary>
	);
};

export default Placeholder;
